// import { useEffect, useState, useMemo, useCallback } from "react";
// import {
//   Container, Grid, Card, CardContent, Typography, Box, LinearProgress,
//   Tooltip, Divider, Paper, Button, TextField, InputAdornment, MenuItem,
//   FormControl, InputLabel, Select, IconButton, CircularProgress,
//   ToggleButton, ToggleButtonGroup
// } from "@mui/material";
// import {
//   ParksBySectorCard,
//   ParksByOccupancyCard,
//   HandoverCard,
//   //the flf are newww
//   InvestorActivityReportCard,
//  } from "../Shared/DashboardCards";
// import {
//   Business as BusinessIcon,
//   TrendingUp as TrendingUpIcon,
//   TrendingDown as TrendingDownIcon,
//   WarningAmber as WarningIcon,
//   Receipt as ReceiptIcon,
//   AccountBalance as AccountBalanceIcon,
//   AttachMoney as MoneyIcon,
//   Assessment as AssessmentIcon,
//   Search as SearchIcon,
//   Clear as ClearIcon,
//   Download as DownloadIcon,
//   BarChart as BarChartIcon,
//   PieChart as PieChartIcon,
//   ShowChart as ShowChartIcon,
//   People as PeopleIcon,
//   LocationOn as LocationOnIcon,
//   CheckCircle as CheckCircleIcon,
//   Warehouse as WarehouseIcon,
//   ViewModule as ViewModuleIcon,
//   Straighten as StraightenIcon,
//   Home as HomeIcon,
//   Agriculture as AgricultureIcon,
//   Map as MapIcon
// } from "@mui/icons-material";
// import { format } from "date-fns";
// import { GetDataFromApiWithParams } from "../../../services/api/ExecuteApiRequests";
// import { IPDCWelcomeMessage } from "../../../components";

// // ==================== HELPER FUNCTIONS ====================
// const toNumber = (value) => {
//   if (typeof value === 'number' && !isNaN(value)) return value;
//   if (typeof value === 'string') {
//     const num = parseFloat(value.replace(/,/g, ''));
//     return isNaN(num) ? 0 : num;
//   }
//   return 0;
// };

// const formatNumber = (number) => {
//   const num = toNumber(number);
//   if (num === 0) return "0";
//   return new Intl.NumberFormat('en-US').format(num);
// };

// const formatCurrency = (amount, paymentMode = "usd") => {
//   const formatted = formatNumber(amount);
//   const mode = paymentMode?.toLowerCase() || "usd";
//   if (mode === "usd") return `$${formatted}`;
//   return `${formatted} ETB`;
// };

// const formatCurrencyUSD = (amount) => `$${formatNumber(amount)}`;
// const formatCurrencyETB = (amount) => `${formatNumber(amount)} ETB`;
// const formatPercentage = (value) => {
//   const num = toNumber(value);
//   if (num === 0) return "0%";
//   return `${num.toFixed(1)}%`;
// };

// const normalizeCurrency = (paymentMode) => {
//   if (!paymentMode) return "unknown";
//   const mode = paymentMode.toLowerCase();
//   if (mode === "usd" || mode === "USD") return "usd";
//   if (mode === "birr" || mode === "etb" ||  mode === "Birr") return "birr";
//   return mode;
// };

// // ==================== PROGRESS BAR COMPONENT ====================
// const ProgressBarCell = ({ value, label, color }) => {
//   const percentage = Math.min(100, Math.max(0, toNumber(value)));
//   const barColor = color || (percentage >= 80 ? "#2e7d32" : percentage >= 60 ? "#ff9800" : "#d32f2f");
//   return (
//     <Box sx={{ minWidth: 80 }}>
//       <Tooltip title={`${label}: ${formatPercentage(percentage)}`} arrow>
//         <Box>
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.3 }}>
//             <Typography variant="caption" sx={{ fontSize: '0.6rem', color: barColor, fontWeight: 'bold' }}>
//               {formatPercentage(percentage)}
//             </Typography>
//           </Box>
//           <LinearProgress
//             variant="determinate"
//             value={percentage}
//             sx={{
//               height: 5, borderRadius: 2.5, backgroundColor: '#e0e0e0',
//               '& .MuiLinearProgress-bar': { backgroundColor: barColor, borderRadius: 2.5 }
//             }}
//           />
//         </Box>
//       </Tooltip>
//     </Box>
//   );
// };

// // ==================== DONUT CHART COMPONENT ====================
// const DonutChartComponent = ({ title, data, colors, formatValue, total, sx }) => {
//   const items = Object.keys(data);
//   const totalValue = total || items.reduce((sum, key) => sum + (data[key] || 0), 0);
//   const donutColors = colors || ['#005F73', '#0A9396', '#94D2BD', '#E9D8A6', '#EE9B00', '#CA6702', '#BB3E03', '#AE2012'];
  
//   if (items.length === 0 || totalValue === 0) {
//     return (
//       <Box sx={{ p: 2, textAlign: 'center', bgcolor: '#fafafa', borderRadius: 2, height: '100%', ...sx }}>
//         <Typography variant="body2" color="textSecondary">No data available</Typography>
//       </Box>
//     );
//   }
  
//   let startAngle = 0;
//   const centerX = 80, centerY = 80, radius = 55;
//   const svgSize = 180;
  
//   return (
//     <Box sx={{ p: 0.5, bgcolor: '#e3f2fd', borderRadius: 2, height: '100%', ...sx }}>
//       <Typography variant="subtitle2" sx={{  textAlign: 'center', mb: 1, fontSize: '1.2rem' }}>{title}</Typography>
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
//         <Box sx={{ position: 'relative', width: svgSize, height: svgSize }}>
//           <svg width={svgSize} height={svgSize} viewBox={`0 0 ${svgSize} ${svgSize}`}>
//             {items.map((key, index) => {
//               const value = data[key] || 0;
//               const percentage = totalValue > 0 ? (value / totalValue) * 100 : 0;
//               const angle = (percentage / 100) * 360;
//               const endAngle = startAngle + angle;
//               const startRad = (startAngle * Math.PI) / 180;
//               const endRad = (endAngle * Math.PI) / 180;
//               const x1 = centerX + radius * Math.cos(startRad);
//               const y1 = centerY + radius * Math.sin(startRad);
//               const x2 = centerX + radius * Math.cos(endRad);
//               const y2 = centerY + radius * Math.sin(endRad);
//               const largeArcFlag = angle > 180 ? 1 : 0;
//               const pathData = `M ${centerX} ${centerY} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2} Z`;
//               const slice = <path key={key} d={pathData} fill={donutColors[index % donutColors.length]} stroke="white" strokeWidth="2" />;
//               startAngle = endAngle;
//               return slice;
//             })}
//             <circle cx={centerX} cy={centerY} r="32" fill="white" />
//             <text x={centerX} y={centerY - 5} textAnchor="middle" fontSize="7" fill="#666">Total</text>
//             <text x={centerX} y={centerY + 8} textAnchor="middle" fontSize="8" fontWeight="bold" fill="#1976d2">{formatValue(totalValue)}</text>
//           </svg>
//         </Box>
//         <Box sx={{ minWidth: 120, maxHeight: 160, overflowY: 'auto' }}>
//           {items.slice(0, 5).map((key, index) => {
//             const value = data[key] || 0;
//             const percentage = totalValue > 0 ? ((value / totalValue) * 100).toFixed(1) : 0;
//             return (
//               <Box key={key} sx={{ display: 'flex', alignItems: 'center', gap: 0.8, mb: 0.5 }}>
//                 <Box sx={{ width: 10, height: 10, bgcolor: donutColors[index % donutColors.length], borderRadius: 1 }} />
//                 <Typography variant="caption" sx={{ fontSize: '0.7rem', flex: 1 }}>{key.length > 15 ? key.substring(0, 12) + '...' : key}</Typography>
//                 <Typography variant="caption" sx={{ fontSize: '0.7rem' }}>{formatValue(value)} ({percentage}%)</Typography>
//               </Box>
//             );
//           })}
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// // ==================== HORIZONTAL BAR CHART ====================
// const HorizontalBarChart = ({ title, data, dataKey, color, formatValue, sx }) => {
//   // Convert flat data to the expected format if needed
//   let processedData = data;
  
//   // Check if data is in flat format (values are numbers, not objects)
//   const isFlatFormat = Object.values(data).some(value => typeof value === 'number');
  
//   if (isFlatFormat) {
//     // Convert flat data to nested format
//     processedData = {};
//     Object.keys(data).forEach(key => {
//       processedData[key] = { [dataKey]: data[key] };
//     });
//   }
  
//   const items = Object.keys(processedData);
//   const maxValue = Math.max(...Object.values(processedData).map(d => d[dataKey] || 0), 0);
  
//   if (items.length === 0 || maxValue === 0) {
//     return (
//       <Box sx={{ p: 2, textAlign: 'center', bgcolor: '#F7F1F1', borderRadius: 2, height: '100%', ...sx }}>
//         <Typography variant="body2" color="textSecondary">No data available</Typography>
//       </Box>
//     );
//   }
  
//   return (
//     <Box sx={{ p: 1.5, bgcolor: '#F7F1F1', borderRadius: 2, height: '100%', ...sx }}>
//       <Typography variant="subtitle2" sx={{  textAlign: 'center', mb: 1.5, fontSize: '1.2rem' }}>{title}</Typography>
//       <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//         {items.slice(0, 6).map((item) => {
//           const value = processedData[item][dataKey] || 0;
//           const percentage = maxValue > 0 ? (value / maxValue) * 100 : 0;
//           return (
//             <Box key={item}>
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.3 }}>
//                 <Typography variant="caption" sx={{ fontSize: '0.7rem', fontWeight: 500 }}>{item.length > 15 ? item.substring(0, 12) + '...' : item}</Typography>
//                 <Typography variant="caption" sx={{ fontSize: '0.7rem', fontWeight: 'bold', color: color }}>{formatValue(value)}</Typography>
//               </Box>
//               <LinearProgress variant="determinate" value={percentage} sx={{ height: 8, borderRadius: 4, backgroundColor: '#e0e0e0', '& .MuiLinearProgress-bar': { backgroundColor: color, borderRadius: 4 } }} />
//             </Box>
//           );
//         })}
//       </Box>
//     </Box>
//   );
// };

// // ==================== INVOICE STATUS TRACKER ====================
// const InvoiceStatusTracker = ({ revenueData, arrearsData }) => {
//   const [activeCurrency, setActiveCurrency] = useState('usd');
  
//   const totalInvoicedUSD = revenueData.filter(i => normalizeCurrency(i.payment_mode) === "usd" || normalizeCurrency(i.payment_mode) === "USD").reduce((s, i) => s + (i.amount || 0), 0);
//   const totalOutstandingUSD = arrearsData.filter(i => normalizeCurrency(i.payment_mode) === "usd").reduce((s, i) => s + (i.outstanding || 0), 0);
//   const totalCollectedUSD = Math.max(0, totalInvoicedUSD - totalOutstandingUSD);


//   const paidPercentageUSD = totalInvoicedUSD > 0 ? (totalCollectedUSD / totalInvoicedUSD) * 100 : 0;
  
//   const totalInvoicedETB = revenueData.filter(i => normalizeCurrency(i.payment_mode) === "birr" ||  normalizeCurrency(i.payment_mode) === "Birr").reduce((s, i) => s + (i.amount || 0), 0);
//   const totalOutstandingETB = arrearsData.filter(i => normalizeCurrency(i.payment_mode) === "birr").reduce((s, i) => s + (i.outstanding || 0), 0);
//   const totalCollectedETB = Math.max(0, totalInvoicedETB - totalOutstandingETB);
//   const paidPercentageETB = totalInvoicedETB > 0 ? (totalCollectedETB / totalInvoicedETB) * 100 : 0;
  
//   const DonutChart = ({ collected, outstanding, total, collectedPercent, currencySymbol }) => {
//     const circumference = 2 * Math.PI * 40;
//     const collectedDash = (collectedPercent / 100) * circumference;
//     const outstandingDash = (100 - collectedPercent) / 100 * circumference;
    
//     return (
//       <Box sx={{ position: 'relative', width: 100, height: 100 }}>
//         <svg viewBox="0 0 100 100" style={{ transform: 'rotate(-90deg)' }}>
//           <circle cx="50" cy="50" r="40" fill="#f5f5f5" stroke="#e0e0e0" strokeWidth="1" />
//           <circle cx="50" cy="50" r="40" fill="none" stroke="#4caf50" strokeWidth="12" strokeDasharray={`${collectedDash} ${circumference}`} strokeLinecap="round" />
//           <circle cx="50" cy="50" r="40" fill="none" stroke="#d32f2f" strokeWidth="12" strokeDasharray={`${outstandingDash} ${circumference}`} strokeDashoffset={`-${collectedDash}`} strokeLinecap="round" />
//           <circle cx="50" cy="50" r="30" fill="white" />
//           <text x="50" y="46" textAnchor="middle" fontSize="10" fill="#333">Total</text>
//           <text x="50" y="58" textAnchor="middle" fontSize="10" fill="#1976d2">{currencySymbol}{formatNumber(total)}
//           </text>
//         </svg>
//       </Box>
//     );
//   };
  
//   return (
//     <Box>
//       <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
//         <ToggleButtonGroup value={activeCurrency} exclusive onChange={(e, val) => val && setActiveCurrency(val)} size="small">
//           <ToggleButton value="usd">USD</ToggleButton>
//           <ToggleButton value="etb">ETB</ToggleButton>
//         </ToggleButtonGroup>
//       </Box>
      
//       {activeCurrency === 'usd' && (
//         <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
//           <DonutChart collected={totalCollectedUSD} outstanding={totalOutstandingUSD} total={totalInvoicedUSD} collectedPercent={paidPercentageUSD} currencySymbol="$" />
//           <Box>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}><Box sx={{ width: 12, height: 12, bgcolor: '#4caf50', borderRadius: 1 }} /><Typography variant="caption">Collected: ${formatNumber(totalCollectedUSD)} ({paidPercentageUSD.toFixed(1)}%)</Typography></Box>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><Box sx={{ width: 12, height: 12, bgcolor: '#d32f2f', borderRadius: 1 }} /><Typography variant="caption">Outstanding: ${formatNumber(totalOutstandingUSD)}</Typography></Box>
//           </Box>
//         </Box>
//       )}
      
//       {activeCurrency === 'etb' && (
//         <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
//           <DonutChart collected={totalCollectedETB} outstanding={totalOutstandingETB} total={totalInvoicedETB} collectedPercent={paidPercentageETB} currencySymbol="" />
//           <Box>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}><Box sx={{ width: 12, height: 12, bgcolor: '#4caf50', borderRadius: 1 }} /><Typography variant="caption">Collected: {formatNumber(totalCollectedETB)} ETB ({paidPercentageETB.toFixed(1)}%)</Typography></Box>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><Box sx={{ width: 12, height: 12, bgcolor: '#d32f2f', borderRadius: 1 }} /><Typography variant="caption">Outstanding: {formatNumber(totalOutstandingETB)} ETB</Typography></Box>
//           </Box>
//         </Box>
//       )}
//     </Box>
//   );
// };

// // ==================== LAND USE PIE CHART ====================
// const LandUsePieChart = ({ data, total, formatValue }) => {
//   const items = Object.keys(data);
//   const colors = ['#1976d2', '#4caf50', '#795548'];
  
//   if (items.length === 0 || total === 0) {
//     return <Typography variant="body2" color="textSecondary">No land use data available</Typography>;
//   }
  
//   let startAngle = 0;
//   const centerX = 80, centerY = 80, radius = 60;
//   const svgSize = 160;
  
//   return (
//     <Box sx={{ textAlign: 'center', bgcolor: '#e3f2fd', p: 2, borderRadius: 2, height: '100%' }}>
//       <Typography variant="subtitle2" sx={{  mb: 1, fontSize: '1.2rem'}} >Land Use Proportion</Typography>
//       <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mb: 1 }}>Total: {formatValue(total)} m²</Typography>
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
//         <Box sx={{ position: 'relative', width: svgSize, height: svgSize }}>
//           <svg width={svgSize} height={svgSize} viewBox={`0 0 ${svgSize} ${svgSize}`}>
//             {items.map((key, index) => {
//               const value = data[key] || 0;
//               const percentage = total > 0 ? (value / total) * 100 : 0;
//               const angle = (percentage / 100) * 360;
//               const endAngle = startAngle + angle;
//               const startRad = (startAngle * Math.PI) / 180;
//               const endRad = (endAngle * Math.PI) / 180;
//               const x1 = centerX + radius * Math.cos(startRad);
//               const y1 = centerY + radius * Math.sin(startRad);
//               const x2 = centerX + radius * Math.cos(endRad);
//               const y2 = centerY + radius * Math.sin(endRad);
//               const largeArcFlag = angle > 180 ? 1 : 0;
//               const pathData = `M ${centerX} ${centerY} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2} Z`;
//               const slice = <path key={key} d={pathData} fill={colors[index % colors.length]} stroke="white" strokeWidth="1.5" />;
//               startAngle = endAngle;
//               return slice;
//             })}
//           </svg>
//         </Box>
//         <Box>
//           {items.map((key, index) => {
//             const value = data[key] || 0;
//             const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
//             return (
//               <Box key={key} sx={{ display: 'flex', alignItems: 'center' }}>
//                 <Box sx={{ width: 10, height: 10, bgcolor: colors[index % colors.length], borderRadius: 1 }} />
//                 <Typography variant="caption">{key}: {formatValue(value)} m² ({percentage}%)</Typography>
//               </Box>
//             );
//           })}
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// // ==================== CONVERSION GAUGE CHART ====================
// const ConversionGaugeChart = ({ conversionRate, potentialCount, investorCount }) => {
//   const percentage = Math.min(100, Math.max(0, conversionRate));
//   const getColor = () => percentage >= 70 ? '#4caf50' : percentage >= 40 ? '#ff9800' : '#f44336';
  
//   return (
//     <Box sx={{ textAlign: 'center', p: 2, bgcolor: '#F7F1F1', borderRadius: 2, height: '100%' }}>
//       <Typography variant="subtitle1" sx={{  color: '#1A237E', mb: 2, fontSize: '1.2rem' }}>Investor Conversion Rate</Typography>
//       <Box sx={{ position: 'relative', display: 'inline-block' }}>
//         <svg width={220} height={140} viewBox="0 0 220 140">
//           <path d="M 20 100 A 80 80 0 0 1 180 100" fill="none" stroke="#e0e0e0" strokeWidth="15" strokeLinecap="round" />
//           <path d={`M 20 100 A 80 80 0 ${percentage > 50 ? 1 : 0} 1 ${100 + 80 * Math.cos(Math.PI + (percentage * Math.PI) / 180)} ${100 - 10 + 80 * Math.sin(Math.PI + (percentage * Math.PI) / 180)}`} fill="none" stroke={getColor()} strokeWidth="15" strokeLinecap="round" />
//           <text x={100} y={125} textAnchor="middle" fontSize="24" fontWeight="bold" fill={getColor()}>{formatPercentage(percentage)}</text>
//         </svg>
//       </Box>
//       <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center', gap: 4 }}>
//         <Box textAlign="center"><Typography variant="caption">Potential Investors</Typography><Typography variant="h6" fontWeight="bold" color="#ff9800">{formatNumber(potentialCount)}</Typography></Box>
//         <Box textAlign="center"><Typography variant="caption">→ Converted →</Typography></Box>
//         <Box textAlign="center"><Typography variant="caption">Registered Investors</Typography><Typography variant="h6" fontWeight="bold" color="#4caf50">{formatNumber(investorCount)}</Typography></Box>
//       </Box>
//     </Box>
//   );
// };

// // ==================== MAIN DASHBOARD ====================
// export default function MergedDashboard() {
//   const [loading, setLoading] = useState(true);
  
//   // Data States
//   const [parksData, setParksData] = useState([]);
//   const [parcelsData, setParcelsData] = useState([]);
//   const [shedsData, setShedsData] = useState([]);
//   const [greenAreasData, setGreenAreasData] = useState([]);
//   const [roadsData, setRoadsData] = useState([]);
//   const [landLeasedData, setLandLeasedData] = useState([]);
//   const [revenueData, setRevenueData] = useState([]);
//   const [arrearsData, setArrearsData] = useState([]);
//   const [employmentData, setEmploymentData] = useState([]);
//   const [tradeData, setTradeData] = useState([]);
//   const [investorsData, setInvestorsData] = useState([]);
//   const [potentialInvestors, setPotentialInvestors] = useState([]);
  
//   // Summary Stats
//   const [summaryStats, setSummaryStats] = useState({
//     occupancyRate: 0, parcelRatio: 0, totalParkArea: 0, totalOccupiedArea: 0,
//     totalParcels: 0, totalOccupiedParcels: 0, totalParks: 0, totalSheds: 0,
//     totalShedArea: 0, totalParcelArea: 0, shedOccupancy: 0
//   });
//   const [landUseData, setLandUseData] = useState({ 'Parcels': 0, 'Green Areas': 0, 'Roads': 0 });
//   const [leasedLandStats, setLeasedLandStats] = useState({ totalLeasedLand: 0, occupiedLeasedLand: 0, landLeaseRatio: 0 });
//   const [promotionStats, setPromotionStats] = useState({
//     totalInvestors: 0, totalPotential: 0, conversionRate: 0, convertedCount: 0,
//     totalCapital: 0, topSectors: {}, topParks: {}, topCountries: {}
//   });
  
//   // Helper functions
//   const calculateGreenAreaTotal = useCallback((parkId) => {
//     if (!greenAreasData || !Array.isArray(greenAreasData)) return 0;
//     return greenAreasData.filter(item => toNumber(item.park_id) === toNumber(parkId)).reduce((sum, item) => sum + toNumber(item.capacity || item.area || 0), 0);
//   }, [greenAreasData]);
  
//   const calculateRoadAreaTotal = useCallback((parkId) => {
//     if (!roadsData || !Array.isArray(roadsData)) return 0;
//     return roadsData.filter(item => toNumber(item.park_id) === toNumber(parkId)).reduce((sum, item) => sum + toNumber(item.capacity || item.area || 0), 0);
//   }, [roadsData]);
  
//   // Calculate metrics
//   const calculateSummaryStats = useCallback(() => {
//     let totalParkArea = 0, totalOccupiedArea = 0, totalParcels = 0, totalOccupiedParcels = 0;
//     let totalSheds = 0, totalOccupiedSheds = 0, totalParcelArea = 0, totalShedArea = 0;
//     let totalGreenArea = 0, totalRoadArea = 0;
    
//     parksData.forEach(park => {
//       const parkArea = toNumber(park.area_on_plan || 0);
//       const parkParcels = parcelsData.filter(p => toNumber(p.park_id) === toNumber(park.id));
//       const occupiedArea = parkParcels.filter(p => p.occupancy_status === "Occupied" || p.status === "Leased").reduce((sum, p) => sum + toNumber(p.area), 0);
//       const occupiedParcels = parkParcels.filter(p => p.occupancy_status === "Occupied" || p.status === "Leased").length;
//       const parkSheds = shedsData.filter(s => toNumber(s.park_id) === toNumber(park.id));
//       const occupiedSheds = parkSheds.filter(s => s.status_utilization === "Occupied").length;
//       const parcelArea = parkParcels.reduce((sum, p) => sum + toNumber(p.area), 0);
//       const shedArea = parkSheds.reduce((sum, s) => sum + toNumber(s.shed_size), 0);
      
//       totalParkArea += parkArea;
//       totalOccupiedArea += occupiedArea;
//       totalParcels += parkParcels.length;
//       totalOccupiedParcels += occupiedParcels;
//       totalSheds += parkSheds.length;
//       totalOccupiedSheds += occupiedSheds;
//       totalParcelArea += parcelArea;
//       totalShedArea += shedArea;
//       totalGreenArea += calculateGreenAreaTotal(park.id);
//       totalRoadArea += calculateRoadAreaTotal(park.id);
//     });
    
//     setSummaryStats({
//       occupancyRate: totalParkArea > 0 ? (totalOccupiedArea / totalParkArea) * 100 : 0,
//       parcelRatio: totalParcels > 0 ? (totalOccupiedParcels / totalParcels) * 100 : 0,
//       totalParkArea, totalOccupiedArea, totalParcels, totalOccupiedParcels,
//       totalParks: parksData.length, totalSheds, totalShedArea, totalParcelArea,
//       totalOccupiedSheds, shedOccupancy: totalSheds > 0 ? (totalOccupiedSheds / totalSheds) * 100 : 0
//     });
    
//     setLandUseData({ 'Parcels': totalParcelArea, 'Green Areas': totalGreenArea, 'Roads': totalRoadArea });
    
//     let totalLeasedLand = 0, occupiedLeasedLand = 0;
//     landLeasedData.forEach(item => {
//       const parcel = parcelsData.find(p => p.upin === item.upin);
//       const area = parcel ? toNumber(parcel.area) : 0;
//       totalLeasedLand += area;
//       if (item.parcel_state === 'Occupied') occupiedLeasedLand += area;
//     });
//     setLeasedLandStats({ totalLeasedLand, occupiedLeasedLand, landLeaseRatio: totalLeasedLand > 0 ? (occupiedLeasedLand / totalLeasedLand) * 100 : 0 });
//   }, [parksData, parcelsData, shedsData, landLeasedData, calculateGreenAreaTotal, calculateRoadAreaTotal]);
  
//   const calculatePromotionMetrics = useCallback(() => {
//     const totalInvestors = investorsData.length;
//     const totalPotential = potentialInvestors.length;
//     const convertedCount = potentialInvestors.filter(pot => investorsData.some(inv => inv.email?.toLowerCase() === pot.email?.toLowerCase())).length;
//     const conversionRate = totalPotential > 0 ? (convertedCount / totalPotential) * 100 : 0;
//     const totalCapital = investorsData.reduce((s, i) => s + toNumber(i.capital), 0);
    
//     const sectorDistribution = {};
//     potentialInvestors.forEach(pot => { const sector = pot.sector_of_interest || "Unknown"; sectorDistribution[sector] = (sectorDistribution[sector] || 0) + 1; });
//     const topSectors = Object.fromEntries(Object.entries(sectorDistribution).sort((a, b) => b[1] - a[1]).slice(0, 5));
    
//     const parkDistribution = {};
//     potentialInvestors.forEach(pot => { const park = pot.park_interested_in || "Unknown"; parkDistribution[park] = (parkDistribution[park] || 0) + 1; });
//     const topParks = Object.fromEntries(Object.entries(parkDistribution).sort((a, b) => b[1] - a[1]).slice(0, 5));
    
//     const countryDistribution = {};
//     investorsData.forEach(inv => { const country = inv.nationality_origin || "Unknown"; countryDistribution[country] = (countryDistribution[country] || 0) + 1; });
//     const topCountries = Object.fromEntries(Object.entries(countryDistribution).sort((a, b) => b[1] - a[1]).slice(0, 5));
    
//     setPromotionStats({ totalInvestors, totalPotential, conversionRate, convertedCount, totalCapital, topSectors, topParks, topCountries });
//   }, [investorsData, potentialInvestors]);
  
//   // Chart data
//   const revenueByPark = useMemo(() => {
//     const map = {};
//     revenueData.forEach(r => { if (r.park_name && r.park_name !== "N/A") map[r.park_name] = (map[r.park_name] || 0) + (r.amount || 0); });
//     return Object.fromEntries(Object.entries(map).sort((a, b) => b[1] - a[1]).slice(0, 6));
//   }, [revenueData]);

//   const outstandingByPark = useMemo(() => {
//     const map = {};
//     arrearsData.forEach(a => { if (a.park_name && a.park_name !== "N/A") map[a.park_name] = (map[a.park_name] || 0) + (a.outstanding || 0); });
//     return Object.fromEntries(Object.entries(map).sort((a, b) => b[1] - a[1]).slice(0, 6));
//   }, [arrearsData]);
  
//   const investmentByType = useMemo(() => {
//     const map = {};
//     investorsData.forEach(i => { const type = i.investment_type || "Other"; map[type] = (map[type] || 0) + 1; });
//     return Object.fromEntries(Object.entries(map).sort((a, b) => b[1] - a[1]).slice(0, 5));
//   }, [investorsData]);
  
//   const code2Metrics = useMemo(() => {
//     const totalRevenueUSD = revenueData.filter(r => normalizeCurrency(r.payment_mode) === "usd").reduce((s, r) => s + (r.amount || 0), 0);
//     const totalRevenueETB = revenueData.filter(r => normalizeCurrency(r.payment_mode) === "birr").reduce((s, r) => s + (r.amount || 0), 0);
//     const totalOutstandingUSD = arrearsData.filter(a => normalizeCurrency(a.payment_mode) === "usd").reduce((s, a) => s + (a.outstanding || 0), 0);
//     const totalOutstandingETB = arrearsData.filter(a => normalizeCurrency(a.payment_mode) === "birr").reduce((s, a) => s + (a.outstanding || 0), 0);
//     const totalEmployees = employmentData.reduce((s, e) => s + (e.emp_labor_female + e.emp_labor_male + e.emp_prof_female + e.emp_prof_male), 0);
//     const totalExport = tradeData.reduce((s, t) => s + (t.export_amount || 0), 0);
//     const totalImport = tradeData.reduce((s, t) => s + (t.import_amount || 0), 0);
//     return { totalRevenueUSD, totalRevenueETB, totalOutstandingUSD, totalOutstandingETB, totalEmployees, totalExport, totalImport };
//   }, [revenueData, arrearsData, employmentData, tradeData]);
  
//   // Fetch all data
//   useEffect(() => {
//     const fetchAllData = async () => {
//       setLoading(true);
//       try {
//         const [parks, parcels, sheds, greenAreas, roads, leasedland, revenue, arrears, employment, trade, investors, potential] = await Promise.all([
//           GetDataFromApiWithParams(`parks/parksummary`),
//           GetDataFromApiWithParams(`parks/parcelsummary`),
//           GetDataFromApiWithParams(`parks/shedsummary`),
//           GetDataFromApiWithParams(`parks/greenareasummary`),
//           GetDataFromApiWithParams(`parks/roadsummary`),
//           GetDataFromApiWithParams(`parks/landleasedsummary`),
//           GetDataFromApiWithParams(`finances/revenuereport`),
//           GetDataFromApiWithParams(`finances/arrearreport`),
//           GetDataFromApiWithParams(`investors/getemployment`),
//           GetDataFromApiWithParams(`investors/getemployment`), // FIXED: Changed from getemployment to gettrade
//           GetDataFromApiWithParams(`investors/getinverstor`),
//           GetDataFromApiWithParams(`prospectiveInvestors`)
//         ]);
        
//         setParksData(parks || []);
//         setParcelsData(parcels || []);
//         setShedsData((sheds || []).map(s => ({ ...s, park_id: toNumber(s.park_id), shed_size: toNumber(s.shed_size) })));
//         setGreenAreasData(greenAreas || []);
//         setRoadsData(roads || []);
//         setLandLeasedData(leasedland || []);
        
//         const processRevenue = (data) => {
//           let arr = data && Array.isArray(data) ? data : (data?.data || []);
//           return arr.map(item => ({
//             amount: toNumber(item.amount || item.payment_amount || 0),
//             payment_mode: item.payment_mode || "USD",
//             park_name: item.park_name || item.park,
//             company_name: item.company_name,
//             month: item.month || (item.payment_date ? format(new Date(item.payment_date), 'MM') : "01"),
//             year: item.year || (item.payment_date ? format(new Date(item.payment_date), 'yyyy') : "2024")
//           }));
//         };
        
//         const processArrears = (data) => {
//           let arr = data && Array.isArray(data) ? data : (data?.data || []);
//           return arr.map(item => ({
//             outstanding: toNumber(item.outstanding || 0),
//             payment_mode: item.payment_mode || "USD",
//             park_name: item.park,
//             company_name: item.company_name,
//             overdue_days: item.overdue_date || 0,
//             month: item.month || "01",
//             year: item.year || "2024"
//           }));
//         };
        
//         const processEmployment = (data) => {
//           let arr = data && Array.isArray(data) ? data : (data?.data || []);
//           return arr.map(item => ({
//             emp_labor_female: toNumber(item.emp_labor_female),
//             emp_labor_male: toNumber(item.emp_labor_male),
//             emp_prof_female: toNumber(item.emp_prof_female),
//             emp_prof_male: toNumber(item.emp_prof_male),
//             park_name: item.park_name,
//             year: item.year || "2024"
//           }));
//         };
        
//         const processTrade = (data) => {
//           let arr = data && Array.isArray(data) ? data : (data?.data || []);
//           return arr.map(item => ({
//             export_amount: toNumber(item.export_amount),
//             import_amount: toNumber(item.import_amount),
//             import_substitution: toNumber(item.import_substitution),
//             park_name: item.park_name,
//             year: item.year || "2024"
//           }));
//         };
        
//         const processInvestors = (data) => {
//           let arr = data && Array.isArray(data) ? data : (data?.data || []);
//           return arr.map(item => ({
//             id: item.id,
//             company_name: item.company_name,
//             capital: toNumber(item.capital),
//             nationality_origin: item.nationality_origin,
//             status: item.status,
//             email: item.email,
//             investment_type: item.investment_type
//           }));
//         };
        
//         // Process all data
//         const processedRevenue = processRevenue(revenue);
//         const processedArrears = processArrears(arrears);
//         const processedEmployment = processEmployment(employment);
//         const processedTrade = processTrade(trade);
//         const processedInvestors = processInvestors(investors);
        
//         setRevenueData(processedRevenue);
//         setArrearsData(processedArrears);
//         setEmploymentData(processedEmployment);
//         setTradeData(processedTrade);
//         setInvestorsData(processedInvestors);
//         setPotentialInvestors(potential && Array.isArray(potential) ? potential : (potential?.data || []));
        
//       } catch (error) {
//         console.error("Failed to fetch data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchAllData();
//   }, []);
  
//   useEffect(() => { if (parksData.length) calculateSummaryStats(); }, [parksData, parcelsData, shedsData, landLeasedData, calculateSummaryStats]);
//   useEffect(() => { if (investorsData.length || potentialInvestors.length) calculatePromotionMetrics(); }, [investorsData, potentialInvestors, calculatePromotionMetrics]);
  
//   if (loading) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//         <CircularProgress /><Typography sx={{ ml: 2 }}>Loading dashboard data...</Typography>
//       </Box>
//     );
//   }
  
//   return (
//     <Box sx={{ bgcolor: '#f4f9ff', width: '100%', mx: 0, py: 1 }}>
//       {/* Header with margins */}
//       <Box sx={{ color: 'white', py: 2, px: { xs: 2, sm: 3, md: 4 }, bgcolor: '#f4f9ff' }}>
//         <Container maxWidth="xl" sx={{ px: { xs: 1, sm: 2, md: 3 } }}>
//           <IPDCWelcomeMessage messageTitle="CEO" />
//         </Container>
//       </Box>

//       {/* BOLD LINE SEPARATOR 1 with margins */}
//       <Container maxWidth="xl" sx={{ my: 4, px: { xs: 2, sm: 3, md: 4 } }}>
//         <Box sx={{ borderBottom: '2px solid #e0e0e0', width: '100%' }} />
//       </Container>
      
//       {/* ========== SECTION 2: LAND & INFRASTRUCTURE ========== */}
//       <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
//         <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, ml: { xs: 1, sm: 2 } }}>
//           <AgricultureIcon sx={{ color: '#1976d2', mr: 1 }} />
//           <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1a237e' }}>Land & Infrastructure Metrics</Typography>
//         </Box>
//         <Grid container spacing={2} sx={{ mb: 3, px: { xs: 1, sm: 2 } }}>
//           <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex' }}>
//             <Card sx={{ p: 2, bgcolor: '#e3f2fd', width: '100%', display: 'flex', flexDirection: 'column' }}>
//             <Typography variant="caption" sx={{ fontSize: '1.2rem' }}>
//               Occupancy Rate
//             </Typography>
//               <Typography variant="h5" fontWeight="bold">{formatPercentage(summaryStats.occupancyRate)}</Typography>
//               <ProgressBarCell value={summaryStats.occupancyRate} label="Occupancy" />
//             </Card>
//           </Grid>
//           <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex' }}>
//             <Card sx={{ p: 2, bgcolor: '#e3f2fd', width: '100%', display: 'flex', flexDirection: 'column' }}>
//               <Typography variant="caption" sx={{ fontSize: '1.2rem' }}>Parcel Ratio</Typography>
//               <Typography variant="h5" fontWeight="bold">{formatPercentage(summaryStats.parcelRatio)}</Typography>
//               <ProgressBarCell value={summaryStats.parcelRatio} label="Parcel" color="#1976d2" />
//             </Card>
//           </Grid>
//           <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex' }}>
//             <Card sx={{ p: 2, bgcolor: '#e3f2fd', width: '100%', display: 'flex', flexDirection: 'column' }}>
//               <Typography variant="caption" sx={{ fontSize: '1.2rem' }}>Shed Occupancy</Typography>
//               <Typography variant="h5" fontWeight="bold">{formatPercentage(summaryStats.shedOccupancy)}</Typography>
//               <ProgressBarCell value={summaryStats.shedOccupancy} label="Shed" color="#795548" />
//             </Card>
//           </Grid>
//           <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex' }}>
//             <Card sx={{ p: 2, bgcolor: '#e3f2fd', width: '100%', display: 'flex', flexDirection: 'column' }}>
//               <Typography variant="caption" sx={{ fontSize: '1.2rem' }}>Land Lease Ratio</Typography>
//               <Typography variant="h5" fontWeight="bold">{formatPercentage(leasedLandStats.landLeaseRatio)}</Typography>
//               <ProgressBarCell value={leasedLandStats.landLeaseRatio} label="Leased Land" color="#4caf50" />
//             </Card>
//           </Grid>
//         </Grid>
//       </Container>

//       {/* BOLD LINE SEPARATOR 2 with margins */}
//       <Container maxWidth="xl" sx={{ my: 4, px: { xs: 2, sm: 3, md: 4 } }}>
//         <Box sx={{ borderBottom: '2px solid #e0e0e0', width: '100%' }} />
//       </Container>
      
//       {/* ========== SECTION 3: FINANCIAL CHARTS ========== */}
//       <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
//         <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, ml: { xs: 1, sm: 2 } }}>
//           <BarChartIcon sx={{ color: '#1976d2', mr: 1 }} />
//           <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1a237e' }}>Financial Analytics</Typography>
//         </Box>

//         {/* KPI Row - Equal height cards */}
//         <Grid container spacing={2} sx={{ mb: 3, px: { xs: 1, sm: 2 } }}>
//           <Grid item xs={6} md={3} sx={{ display: 'flex' }}>
//             <Card sx={{ p: 2, bgcolor: '#F7F1F1', width: '100%', display: 'flex', flexDirection: 'column' }}>
//               <Typography variant="caption" sx={{ fontSize: '1.2rem' }}>Revenue (USD)</Typography>
//               <Typography variant="h6" fontWeight="bold" color="#2e7d32">{formatCurrencyUSD(code2Metrics.totalRevenueUSD)}</Typography>
//             </Card>
//           </Grid>
//           <Grid item xs={6} md={3} sx={{ display: 'flex' }}>
//             <Card sx={{ p: 2, bgcolor: '#F7F1F1', width: '100%', display: 'flex', flexDirection: 'column' }}>
//               <Typography variant="caption" sx={{ fontSize: '1.2rem' }}>Outstanding (USD)</Typography>
//               <Typography variant="h6" fontWeight="bold" color="#d32f2f">{formatCurrencyUSD(code2Metrics.totalOutstandingUSD)}</Typography>
//             </Card>
//           </Grid>
//           <Grid item xs={6} md={3} sx={{ display: 'flex' }}>
//             <Card sx={{ p: 2, bgcolor: '#F7F1F1', width: '100%', display: 'flex', flexDirection: 'column' }}>
//               <Typography variant="caption" sx={{ fontSize: '1.2rem' }} >Revenue (ETB)</Typography>
//               <Typography variant="h6" fontWeight="bold" color="#2e7d32">{formatCurrencyETB(code2Metrics.totalRevenueETB)}</Typography>
//             </Card>
//           </Grid>
//           <Grid item xs={6} md={3} sx={{ display: 'flex' }}>
//             <Card sx={{ p: 2, bgcolor: '#F7F1F1', width: '100%', display: 'flex', flexDirection: 'column' }}>
//               <Typography variant="caption"  sx={{ fontSize: '1.2rem' }}
//               >Outstanding (ETB)</Typography>
//               <Typography variant="h6" fontWeight="bold" color="#d32f2f">{formatCurrencyETB(code2Metrics.totalOutstandingETB)}</Typography>
//             </Card>
//           </Grid>
//         </Grid>

//         {/* Charts Row - Equal height cards */}
//         <Grid container spacing={2} sx={{ px: { xs: 1, sm: 2 } }}>
//           <Grid item xs={12} md={4} sx={{ display: 'flex' }}>
//             <Box sx={{ width: '100%', height: '100%' }}>
//               <HorizontalBarChart title="Revenue by Park" data={revenueByPark} dataKey="value" color="#1976d2" formatValue={formatCurrencyUSD} />
//             </Box>
//           </Grid>
//           <Grid item xs={12} md={4} sx={{ display: 'flex' }}>
//             <Box sx={{ width: '100%', height: '100%' }}>
//               <DonutChartComponent title="Outstanding by Park" data={outstandingByPark} formatValue={formatCurrencyUSD} colors={['#d32f2f', '#f44336', '#ff9800']} />
//             </Box>
//           </Grid>
//           <Grid item xs={12} md={4} sx={{ display: 'flex' }}>
//             <Card sx={{ p: 2, width: '100%', display: 'flex', flexDirection: 'column' }}>
//               <Typography variant="subtitle1"  mb={2} sx={{ fontSize: '1.2rem' }}>Invoice Status Tracker</Typography>
//               <InvoiceStatusTracker revenueData={revenueData} arrearsData={arrearsData} />
//             </Card>
//           </Grid>
//         </Grid>
//       </Container>

//       {/* BOLD LINE SEPARATOR 3 with margins */}
//       <Container maxWidth="xl" sx={{ my: 4, px: { xs: 2, sm: 3, md: 4 } }}>
//         <Box sx={{ borderBottom: '2px solid #e0e0e0', width: '100%' }} />
//       </Container>
      
//       {/* ========== SECTION 4: INVESTOR AFTERCARE ========== */}
//       <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
//         <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, ml: { xs: 1, sm: 2 } }}>
//           <PeopleIcon sx={{ color: '#1976d2', mr: 1 }} />
//           <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1a237e' }}>Investor Aftercare</Typography>
//         </Box>
        
//         {/* KPI Cards Row - Equal height cards */}
//         <Grid container spacing={2} sx={{ mb: 3, px: { xs: 1, sm: 2 } }}>
//           <Grid item xs={6} sm={3} md={2} sx={{ display: 'flex' }}>
//             <Card sx={{ bgcolor: '#e8f5e9', p: 2, textAlign: 'center', width: '100%', display: 'flex', flexDirection: 'column' }}>
//               <Typography variant="caption" sx={{ fontSize: '1.2rem' }}>Total Parks</Typography>
//               <Typography variant="h5" fontWeight="bold" color="#1976d2">13</Typography>
//             </Card>
//           </Grid>
//           <Grid item xs={6} sm={3} md={2} sx={{ display: 'flex' }}>
//             <Card sx={{ bgcolor: '#e8f5e9', p: 2, textAlign: 'center', width: '100%', display: 'flex', flexDirection: 'column' }}>
//               <Typography variant="caption" sx={{ fontSize: '1.2rem' }}>Total Investors</Typography>
//               <Typography variant="h5" fontWeight="bold" color="#1976d2">{formatNumber(promotionStats.totalInvestors)}</Typography>
//             </Card>
//           </Grid>
//           <Grid item xs={6} sm={3} md={2} sx={{ display: 'flex' }}>
//             <Card sx={{ p: 2, bgcolor: '#e8f5e9', textAlign: 'center', width: '100%', display: 'flex', flexDirection: 'column' }}>
//               <Typography variant="caption" sx={{ fontSize: '1.2rem' }}>Total Export</Typography>
//               <Typography variant="h6" fontWeight="bold" color="#2e7d32">{formatCurrencyUSD(code2Metrics.totalExport)}</Typography>
//             </Card>
//           </Grid>
//           <Grid item xs={6} sm={3} md={2} sx={{ display: 'flex' }}>
//             <Card sx={{ p: 2, bgcolor: '#e8f5e9', textAlign: 'center', width: '100%', display: 'flex', flexDirection: 'column' }}>
//               <Typography variant="caption" sx={{ fontSize: '1.2rem' }}>Total Import</Typography>
//               <Typography variant="h6" fontWeight="bold" color="#ed6c02">{formatCurrencyUSD(code2Metrics.totalImport)}</Typography>
//             </Card>
//           </Grid>
//           <Grid item xs={6} sm={3} md={2} sx={{ display: 'flex' }}>
//             <Card sx={{ p: 2, bgcolor: '#e8f5e9', textAlign: 'center', width: '100%', display: 'flex', flexDirection: 'column' }}>
//               <Typography variant="caption" sx={{ fontSize: '1.2rem' }}>Total Employees</Typography>
//               <Typography variant="h6" fontWeight="bold">{formatNumber(code2Metrics.totalEmployees)}</Typography>
//             </Card>
//           </Grid>
//           <Grid item xs={6} sm={3} md={2} sx={{ display: 'flex' }}>
//             <Card sx={{ p: 2, bgcolor: '#e8f5e9', textAlign: 'center', width: '100%', display: 'flex', flexDirection: 'column' }}>
//               <Typography variant="caption" sx={{ fontSize: '1.2rem' }}>Total Capital</Typography>
//               <Typography variant="caption" sx={{ fontSize: '1rem' }}  color="#9c27b0">{formatCurrencyUSD(promotionStats.totalCapital)}</Typography>
//             </Card>
//           </Grid>
//         </Grid>

//         {/* Charts Row - Equal height cards */}
//         <Grid container spacing={2} sx={{ px: { xs: 1, sm: 2 } }}>
//           <Grid item xs={12} md={4} sx={{ display: 'flex' }}>
//             <Box sx={{ width: '100%', height: '100%' }}>
//               <DonutChartComponent title="Investment Types" data={investmentByType} formatValue={formatNumber} />
//             </Box>
//           </Grid>
//           <Grid item xs={12} md={4} sx={{ display: 'flex' }}>
//             <Box sx={{ width: '100%', height: '100%' }}>
//               <LandUsePieChart data={landUseData} total={summaryStats.totalParcelArea + landUseData['Green Areas'] + landUseData['Roads']} formatValue={formatNumber} />
//             </Box>
//           </Grid>
//           <Grid item xs={12} md={4} sx={{ display: 'flex' }}>
//             <Box sx={{ width: '100%', height: '100%' }}>
//               <ParksBySectorCard wrapLegendText={true} />
//             </Box>
//           </Grid>
//         </Grid>
//       </Container>

     

//       {/* ========== SECTION 5: ACCOUNTS RECEIVABLE ========== */}

//       {/* BOLD LINE SEPARATOR 5 with margins */}
//       <Container maxWidth="xl" sx={{ my: 4, px: { xs: 2, sm: 3, md: 4 } }}>
//         <Box sx={{ borderBottom: '2px solid #e0e0e0', width: '100%' }} />
//       </Container>
      
//       {/* ========== SECTION 6: PROMOTION & MARKETING ========== */}
//       <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
//         <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, ml: { xs: 1, sm: 2 } }}>
//           <TrendingUpIcon sx={{ color: '#1976d2', mr: 1 }} />
//           <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1a237e' }}>Promotion & Marketing</Typography>
//         </Box>
//         <Grid container spacing={2} sx={{ mb: 3, px: { xs: 1, sm: 2 } }}>
//           <Grid item xs={4} sx={{ display: 'flex' }}>
//             <Card sx={{ p: 2, bgcolor: '#e8f5e9', textAlign: 'center', width: '100%', display: 'flex', flexDirection: 'column' }}>
//               <Typography variant="caption" sx={{ fontSize: '1.4rem' }}>Total Investors</Typography>
//               <Typography variant="h5" fontWeight="bold" color="#1976d2">{formatNumber(promotionStats.totalInvestors)}</Typography>
//             </Card>
//           </Grid>
//           <Grid item xs={4} sx={{ display: 'flex' }}>
//             <Card sx={{ p: 2, bgcolor: '#e8f5e9', textAlign: 'center', width: '100%', display: 'flex', flexDirection: 'column' }}>
//               <Typography variant="caption" sx={{ fontSize: '1.2rem' }}>Potential Investors</Typography>
//               <Typography variant="h5" fontWeight="bold" color="#ed6c02">{formatNumber(promotionStats.totalPotential)}</Typography>
//             </Card>
//           </Grid>
//           <Grid item xs={4} sx={{ display: 'flex' }}>
//             <Card sx={{ p: 2, bgcolor: '#e8f5e9', textAlign: 'center', width: '100%', display: 'flex', flexDirection: 'column' }}>
//               <Typography variant="caption" sx={{ fontSize: '1.2rem' }}>Conversion Rate</Typography>
//               <Typography variant="h5" fontWeight="bold" color="#2e7d32">{formatPercentage(promotionStats.conversionRate)}</Typography>
//             </Card>
//           </Grid>
//         </Grid>
//         <Grid container spacing={2} sx={{ px: { xs: 1, sm: 2 } }}>
//           <Grid item xs={12} md={4} sx={{ display: 'flex' }}>
//             <Box sx={{ width: '100%', height: '100%' }}>
//               <HorizontalBarChart title="Top Sectors of Interest" data={promotionStats.topSectors} dataKey="value" color="#ff9800" formatValue={formatNumber} />
//             </Box>
//           </Grid>
//           <Grid item xs={12} md={4} sx={{ display: 'flex' }}>
//             <Box sx={{ width: '100%', height: '100%' }}>
//               <DonutChartComponent title="Top Parks Interest" data={promotionStats.topParks} formatValue={formatNumber} />
//             </Box>
//           </Grid>
//           <Grid item xs={12} md={4} sx={{ display: 'flex' }}>
//             <Box sx={{ width: '100%', height: '100%' }}>
//               <ConversionGaugeChart conversionRate={promotionStats.conversionRate} potentialCount={promotionStats.totalPotential} investorCount={promotionStats.convertedCount} />
//             </Box>
//           </Grid>
//         </Grid>
//       </Container>
//     </Box>
//   );
// }
//************************************************************************************************* */
import { useEffect, useState, useMemo, useCallback } from "react";
import {
  Container, Grid, Card, CardContent, Typography, Box, LinearProgress,
  Tooltip, Divider, Paper, Button, TextField, InputAdornment, MenuItem,
  FormControl, InputLabel, Select, IconButton, CircularProgress,
  ToggleButton, ToggleButtonGroup
} from "@mui/material";
import {
  ParksBySectorCard,
  ParksByOccupancyCard,
  HandoverCard,
  InvestorActivityReportCard,
 } from "../Shared/DashboardCards";
import {
  Business as BusinessIcon,
  TrendingUp as TrendingUpIcon,
  TrendingDown as TrendingDownIcon,
  WarningAmber as WarningIcon,
  Receipt as ReceiptIcon,
  AccountBalance as AccountBalanceIcon,
  AttachMoney as MoneyIcon,
  Assessment as AssessmentIcon,
  Search as SearchIcon,
  Clear as ClearIcon,
  Download as DownloadIcon,
  BarChart as BarChartIcon,
  PieChart as PieChartIcon,
  ShowChart as ShowChartIcon,
  People as PeopleIcon,
  LocationOn as LocationOnIcon,
  CheckCircle as CheckCircleIcon,
  Warehouse as WarehouseIcon,
  ViewModule as ViewModuleIcon,
  Straighten as StraightenIcon,
  Home as HomeIcon,
  Agriculture as AgricultureIcon,
  Map as MapIcon
} from "@mui/icons-material";
import { format } from "date-fns";
import { GetDataFromApiWithParams } from "../../../services/api/ExecuteApiRequests";
import { IPDCWelcomeMessage } from "../../../components";

// ==================== HELPER FUNCTIONS ====================
const toNumber = (value) => {
  if (typeof value === 'number' && !isNaN(value)) return value;
  if (typeof value === 'string') {
    // Remove commas, dollar signs, and other currency symbols
    const cleaned = value.replace(/[$,]/g, '').trim();
    const num = parseFloat(cleaned);
    return isNaN(num) ? 0 : num;
  }
  if (value === null || value === undefined) return 0;
  return 0;
};

const formatNumber = (number) => {
  const num = toNumber(number);
  if (num === 0) return "0";
  return new Intl.NumberFormat('en-US').format(num);
};

const formatCurrency = (amount, paymentMode = "usd") => {
  const formatted = formatNumber(amount);
  const mode = paymentMode?.toLowerCase() || "usd";
  if (mode === "usd") return `$${formatted}`;
  return `${formatted} ETB`;
};

const formatCurrencyUSD = (amount) => `$${formatNumber(amount)}`;
const formatCurrencyETB = (amount) => `${formatNumber(amount)} ETB`;
const formatPercentage = (value) => {
  const num = toNumber(value);
  if (num === 0) return "0%";
  return `${num.toFixed(1)}%`;
};

const normalizeCurrency = (paymentMode) => {
  if (!paymentMode) return "unknown";
  const mode = paymentMode.toLowerCase();
  if (mode === "usd" || mode === "USD") return "usd";
  if (mode === "birr" || mode === "etb" ||  mode === "Birr") return "birr";
  return mode;
};

// ==================== PROGRESS BAR COMPONENT ====================
const ProgressBarCell = ({ value, label, color }) => {
  const percentage = Math.min(100, Math.max(0, toNumber(value)));
  const barColor = color || (percentage >= 80 ? "#2e7d32" : percentage >= 60 ? "#ff9800" : "#d32f2f");
  return (
    <Box sx={{ minWidth: 80 }}>
      <Tooltip title={`${label}: ${formatPercentage(percentage)}`} arrow>
        <Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.3 }}>
            <Typography variant="caption" sx={{ fontSize: '0.6rem', color: barColor, fontWeight: 'bold' }}>
              {formatPercentage(percentage)}
            </Typography>
          </Box>
          <LinearProgress
            variant="determinate"
            value={percentage}
            sx={{
              height: 5, borderRadius: 2.5, backgroundColor: '#e0e0e0',
              '& .MuiLinearProgress-bar': { backgroundColor: barColor, borderRadius: 2.5 }
            }}
          />
        </Box>
      </Tooltip>
    </Box>
  );
};

// ==================== DONUT CHART COMPONENT ====================
const DonutChartComponent = ({ title, data, colors, formatValue, total, sx }) => {
  const items = Object.keys(data);
  const totalValue = total || items.reduce((sum, key) => sum + (data[key] || 0), 0);
  const donutColors = colors || ['#005F73', '#0A9396', '#94D2BD', '#E9D8A6', '#EE9B00', '#CA6702', '#BB3E03', '#AE2012'];
  
  if (items.length === 0 || totalValue === 0) {
    return (
      <Box sx={{ p: 2, textAlign: 'center', bgcolor: '#fafafa', borderRadius: 2, height: '100%', ...sx }}>
        <Typography variant="body2" color="textSecondary">No data available</Typography>
      </Box>
    );
  }
  
  let startAngle = 0;
  const centerX = 80, centerY = 80, radius = 55;
  const svgSize = 180;
  
  return (
    <Box sx={{ p: 0.5, bgcolor: '#e3f2fd', borderRadius: 2, height: '100%', ...sx }}>
      <Typography variant="subtitle2" sx={{  textAlign: 'center', mb: 1, fontSize: '1.2rem' }}>{title}</Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
        <Box sx={{ position: 'relative', width: svgSize, height: svgSize }}>
          <svg width={svgSize} height={svgSize} viewBox={`0 0 ${svgSize} ${svgSize}`}>
            {items.map((key, index) => {
              const value = data[key] || 0;
              const percentage = totalValue > 0 ? (value / totalValue) * 100 : 0;
              const angle = (percentage / 100) * 360;
              const endAngle = startAngle + angle;
              const startRad = (startAngle * Math.PI) / 180;
              const endRad = (endAngle * Math.PI) / 180;
              const x1 = centerX + radius * Math.cos(startRad);
              const y1 = centerY + radius * Math.sin(startRad);
              const x2 = centerX + radius * Math.cos(endRad);
              const y2 = centerY + radius * Math.sin(endRad);
              const largeArcFlag = angle > 180 ? 1 : 0;
              const pathData = `M ${centerX} ${centerY} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2} Z`;
              const slice = <path key={key} d={pathData} fill={donutColors[index % donutColors.length]} stroke="white" strokeWidth="2" />;
              startAngle = endAngle;
              return slice;
            })}
            <circle cx={centerX} cy={centerY} r="32" fill="white" />
            <text x={centerX} y={centerY - 5} textAnchor="middle" fontSize="7" fill="#666">Total</text>
            <text x={centerX} y={centerY + 8} textAnchor="middle" fontSize="8" fontWeight="bold" fill="#1976d2">{formatValue(totalValue)}</text>
          </svg>
        </Box>
        <Box sx={{ minWidth: 120, maxHeight: 160, overflowY: 'auto' }}>
          {items.slice(0, 5).map((key, index) => {
            const value = data[key] || 0;
            const percentage = totalValue > 0 ? ((value / totalValue) * 100).toFixed(1) : 0;
            return (
              <Box key={key} sx={{ display: 'flex', alignItems: 'center', gap: 0.8, mb: 0.5 }}>
                <Box sx={{ width: 10, height: 10, bgcolor: donutColors[index % donutColors.length], borderRadius: 1 }} />
                <Typography variant="caption" sx={{ fontSize: '0.7rem', flex: 1 }}>{key.length > 15 ? key.substring(0, 12) + '...' : key}</Typography>
                <Typography variant="caption" sx={{ fontSize: '0.7rem' }}>{formatValue(value)} ({percentage}%)</Typography>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

// ==================== HORIZONTAL BAR CHART ====================
const HorizontalBarChart = ({ title, data, dataKey, color, formatValue, sx }) => {
  let processedData = data;
  const isFlatFormat = Object.values(data).some(value => typeof value === 'number');
  
  if (isFlatFormat) {
    processedData = {};
    Object.keys(data).forEach(key => {
      processedData[key] = { [dataKey]: data[key] };
    });
  }
  
  const items = Object.keys(processedData);
  const maxValue = Math.max(...Object.values(processedData).map(d => d[dataKey] || 0), 0);
  
  if (items.length === 0 || maxValue === 0) {
    return (
      <Box sx={{ p: 2, textAlign: 'center', bgcolor: '#F7F1F1', borderRadius: 2, height: '100%', ...sx }}>
        <Typography variant="body2" color="textSecondary">No data available</Typography>
      </Box>
    );
  }
  
  return (
    <Box sx={{ p: 1.5, bgcolor: '#F7F1F1', borderRadius: 2, height: '100%', ...sx }}>
      <Typography variant="subtitle2" sx={{  textAlign: 'center', mb: 1.5, fontSize: '1.2rem' }}>{title}</Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {items.slice(0, 6).map((item) => {
          const value = processedData[item][dataKey] || 0;
          const percentage = maxValue > 0 ? (value / maxValue) * 100 : 0;
          return (
            <Box key={item}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.3 }}>
                <Typography variant="caption" sx={{ fontSize: '0.7rem', fontWeight: 500 }}>{item.length > 15 ? item.substring(0, 12) + '...' : item}</Typography>
                <Typography variant="caption" sx={{ fontSize: '0.7rem', fontWeight: 'bold', color: color }}>{formatValue(value)}</Typography>
              </Box>
              <LinearProgress variant="determinate" value={percentage} sx={{ height: 8, borderRadius: 4, backgroundColor: '#e0e0e0', '& .MuiLinearProgress-bar': { backgroundColor: color, borderRadius: 4 } }} />
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

// ==================== INVOICE STATUS TRACKER ====================
const InvoiceStatusTracker = ({ revenueData, arrearsData }) => {
  const [activeCurrency, setActiveCurrency] = useState('usd');
  
  const totalInvoicedUSD = revenueData.filter(i => normalizeCurrency(i.payment_mode) === "usd" || normalizeCurrency(i.payment_mode) === "USD").reduce((s, i) => s + (i.amount || 0), 0);
  const totalOutstandingUSD = arrearsData.filter(i => normalizeCurrency(i.payment_mode) === "usd").reduce((s, i) => s + (i.outstanding || 0), 0);
  const totalCollectedUSD = Math.max(0, totalInvoicedUSD - totalOutstandingUSD);

  const paidPercentageUSD = totalInvoicedUSD > 0 ? (totalCollectedUSD / totalInvoicedUSD) * 100 : 0;
  
  const totalInvoicedETB = revenueData.filter(i => normalizeCurrency(i.payment_mode) === "birr" ||  normalizeCurrency(i.payment_mode) === "Birr").reduce((s, i) => s + (i.amount || 0), 0);
  const totalOutstandingETB = arrearsData.filter(i => normalizeCurrency(i.payment_mode) === "birr").reduce((s, i) => s + (i.outstanding || 0), 0);
  const totalCollectedETB = Math.max(0, totalInvoicedETB - totalOutstandingETB);
  const paidPercentageETB = totalInvoicedETB > 0 ? (totalCollectedETB / totalInvoicedETB) * 100 : 0;
  
  const DonutChart = ({ collected, outstanding, total, collectedPercent, currencySymbol }) => {
    const circumference = 2 * Math.PI * 40;
    const collectedDash = (collectedPercent / 100) * circumference;
    const outstandingDash = (100 - collectedPercent) / 100 * circumference;
    
    return (
      <Box sx={{ position: 'relative', width: 100, height: 100 }}>
        <svg viewBox="0 0 100 100" style={{ transform: 'rotate(-90deg)' }}>
          <circle cx="50" cy="50" r="40" fill="#f5f5f5" stroke="#e0e0e0" strokeWidth="1" />
          <circle cx="50" cy="50" r="40" fill="none" stroke="#4caf50" strokeWidth="12" strokeDasharray={`${collectedDash} ${circumference}`} strokeLinecap="round" />
          <circle cx="50" cy="50" r="40" fill="none" stroke="#d32f2f" strokeWidth="12" strokeDasharray={`${outstandingDash} ${circumference}`} strokeDashoffset={`-${collectedDash}`} strokeLinecap="round" />
          <circle cx="50" cy="50" r="30" fill="white" />
          <text x="50" y="46" textAnchor="middle" fontSize="10" fill="#333">Total</text>
          <text x="50" y="58" textAnchor="middle" fontSize="10" fill="#1976d2">{currencySymbol}{formatNumber(total)}</text>
        </svg>
      </Box>
    );
  };
  
  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
        <ToggleButtonGroup value={activeCurrency} exclusive onChange={(e, val) => val && setActiveCurrency(val)} size="small">
          <ToggleButton value="usd">USD</ToggleButton>
          <ToggleButton value="etb">ETB</ToggleButton>
        </ToggleButtonGroup>
      </Box>
      
      {activeCurrency === 'usd' && (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
          <DonutChart collected={totalCollectedUSD} outstanding={totalOutstandingUSD} total={totalInvoicedUSD} collectedPercent={paidPercentageUSD} currencySymbol="$" />
          <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}><Box sx={{ width: 12, height: 12, bgcolor: '#4caf50', borderRadius: 1 }} /><Typography variant="caption">Collected: ${formatNumber(totalCollectedUSD)} ({paidPercentageUSD.toFixed(1)}%)</Typography></Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><Box sx={{ width: 12, height: 12, bgcolor: '#d32f2f', borderRadius: 1 }} /><Typography variant="caption">Outstanding: ${formatNumber(totalOutstandingUSD)}</Typography></Box>
          </Box>
        </Box>
      )}
      
      {activeCurrency === 'etb' && (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
          <DonutChart collected={totalCollectedETB} outstanding={totalOutstandingETB} total={totalInvoicedETB} collectedPercent={paidPercentageETB} currencySymbol="" />
          <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}><Box sx={{ width: 12, height: 12, bgcolor: '#4caf50', borderRadius: 1 }} /><Typography variant="caption">Collected: {formatNumber(totalCollectedETB)} ETB ({paidPercentageETB.toFixed(1)}%)</Typography></Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><Box sx={{ width: 12, height: 12, bgcolor: '#d32f2f', borderRadius: 1 }} /><Typography variant="caption">Outstanding: {formatNumber(totalOutstandingETB)} ETB</Typography></Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

// ==================== LAND USE PIE CHART ====================
const LandUsePieChart = ({ data, total, formatValue }) => {
  const items = Object.keys(data);
  const colors = ['#1976d2', '#4caf50', '#795548'];
  
  if (items.length === 0 || total === 0) {
    return <Typography variant="body2" color="textSecondary">No land use data available</Typography>;
  }
  
  let startAngle = 0;
  const centerX = 80, centerY = 80, radius = 60;
  const svgSize = 160;
  
  return (
    <Box sx={{ textAlign: 'center', bgcolor: '#e3f2fd', p: 2, borderRadius: 2, height: '100%' }}>
      <Typography variant="subtitle2" sx={{  mb: 1, fontSize: '1.2rem'}} >Land Use Proportion</Typography>
      <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mb: 1 }}>Total: {formatValue(total)} m²</Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
        <Box sx={{ position: 'relative', width: svgSize, height: svgSize }}>
          <svg width={svgSize} height={svgSize} viewBox={`0 0 ${svgSize} ${svgSize}`}>
            {items.map((key, index) => {
              const value = data[key] || 0;
              const percentage = total > 0 ? (value / total) * 100 : 0;
              const angle = (percentage / 100) * 360;
              const endAngle = startAngle + angle;
              const startRad = (startAngle * Math.PI) / 180;
              const endRad = (endAngle * Math.PI) / 180;
              const x1 = centerX + radius * Math.cos(startRad);
              const y1 = centerY + radius * Math.sin(startRad);
              const x2 = centerX + radius * Math.cos(endRad);
              const y2 = centerY + radius * Math.sin(endRad);
              const largeArcFlag = angle > 180 ? 1 : 0;
              const pathData = `M ${centerX} ${centerY} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2} Z`;
              const slice = <path key={key} d={pathData} fill={colors[index % colors.length]} stroke="white" strokeWidth="1.5" />;
              startAngle = endAngle;
              return slice;
            })}
          </svg>
        </Box>
        <Box>
          {items.map((key, index) => {
            const value = data[key] || 0;
            const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
            return (
              <Box key={key} sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ width: 10, height: 10, bgcolor: colors[index % colors.length], borderRadius: 1 }} />
                <Typography variant="caption">{key}: {formatValue(value)} m² ({percentage}%)</Typography>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

// ==================== CONVERSION GAUGE CHART ====================
const ConversionGaugeChart = ({ conversionRate, potentialCount, investorCount }) => {
  const percentage = Math.min(100, Math.max(0, conversionRate));
  const getColor = () => percentage >= 70 ? '#4caf50' : percentage >= 40 ? '#ff9800' : '#f44336';
  
  return (
    <Box sx={{ textAlign: 'center', p: 2, bgcolor: '#F7F1F1', borderRadius: 2, height: '100%' }}>
      <Typography variant="subtitle1" sx={{  color: '#1A237E', mb: 2, fontSize: '1.2rem' }}>Investor Conversion Rate</Typography>
      <Box sx={{ position: 'relative', display: 'inline-block' }}>
        <svg width={220} height={140} viewBox="0 0 220 140">
          <path d="M 20 100 A 80 80 0 0 1 180 100" fill="none" stroke="#e0e0e0" strokeWidth="15" strokeLinecap="round" />
          <path d={`M 20 100 A 80 80 0 ${percentage > 50 ? 1 : 0} 1 ${100 + 80 * Math.cos(Math.PI + (percentage * Math.PI) / 180)} ${100 - 10 + 80 * Math.sin(Math.PI + (percentage * Math.PI) / 180)}`} fill="none" stroke={getColor()} strokeWidth="15" strokeLinecap="round" />
          <text x={100} y={125} textAnchor="middle" fontSize="24" fontWeight="bold" fill={getColor()}>{formatPercentage(percentage)}</text>
        </svg>
      </Box>
      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center', gap: 4 }}>
        <Box textAlign="center"><Typography variant="caption">Potential Investors</Typography><Typography variant="h6" fontWeight="bold" color="#ff9800">{formatNumber(potentialCount)}</Typography></Box>
        <Box textAlign="center"><Typography variant="caption">→ Converted →</Typography></Box>
        <Box textAlign="center"><Typography variant="caption">Registered Investors</Typography><Typography variant="h6" fontWeight="bold" color="#4caf50">{formatNumber(investorCount)}</Typography></Box>
      </Box>
    </Box>
  );
};

// ==================== MAIN DASHBOARD ====================
export default function MergedDashboard() {
  const [loading, setLoading] = useState(true);
  
  // Data States
  const [parksData, setParksData] = useState([]);
  const [parcelsData, setParcelsData] = useState([]);
  const [shedsData, setShedsData] = useState([]);
  const [greenAreasData, setGreenAreasData] = useState([]);
  const [roadsData, setRoadsData] = useState([]);
  const [landLeasedData, setLandLeasedData] = useState([]);
  const [revenueData, setRevenueData] = useState([]);
  const [arrearsData, setArrearsData] = useState([]);
  const [employmentData, setEmploymentData] = useState([]);
  const [tradeData, setTradeData] = useState([]);
  const [investorsData, setInvestorsData] = useState([]);
  const [potentialInvestors, setPotentialInvestors] = useState([]);
  
  // Summary Stats
  const [summaryStats, setSummaryStats] = useState({
    occupancyRate: 0, parcelRatio: 0, totalParkArea: 0, totalOccupiedArea: 0,
    totalParcels: 0, totalOccupiedParcels: 0, totalParks: 0, totalSheds: 0,
    totalShedArea: 0, totalParcelArea: 0, shedOccupancy: 0
  });
  const [landUseData, setLandUseData] = useState({ 'Parcels': 0, 'Green Areas': 0, 'Roads': 0 });
  const [leasedLandStats, setLeasedLandStats] = useState({ totalLeasedLand: 0, occupiedLeasedLand: 0, landLeaseRatio: 0 });
  const [promotionStats, setPromotionStats] = useState({
    totalInvestors: 0, totalPotential: 0, conversionRate: 0, convertedCount: 0,
    totalCapital: 0, topSectors: {}, topParks: {}, topCountries: {}
  });
  
  // Helper functions
  const calculateGreenAreaTotal = useCallback((parkId) => {
    if (!greenAreasData || !Array.isArray(greenAreasData)) return 0;
    return greenAreasData.filter(item => toNumber(item.park_id) === toNumber(parkId)).reduce((sum, item) => sum + toNumber(item.capacity || item.area || 0), 0);
  }, [greenAreasData]);
  
  const calculateRoadAreaTotal = useCallback((parkId) => {
    if (!roadsData || !Array.isArray(roadsData)) return 0;
    return roadsData.filter(item => toNumber(item.park_id) === toNumber(parkId)).reduce((sum, item) => sum + toNumber(item.capacity || item.area || 0), 0);
  }, [roadsData]);
  
  // Calculate metrics
  const calculateSummaryStats = useCallback(() => {
    let totalParkArea = 0, totalOccupiedArea = 0, totalParcels = 0, totalOccupiedParcels = 0;
    let totalSheds = 0, totalOccupiedSheds = 0, totalParcelArea = 0, totalShedArea = 0;
    let totalGreenArea = 0, totalRoadArea = 0;
    
    parksData.forEach(park => {
      const parkArea = toNumber(park.area_on_plan || 0);
      const parkParcels = parcelsData.filter(p => toNumber(p.park_id) === toNumber(park.id));
      const occupiedArea = parkParcels.filter(p => p.occupancy_status === "Occupied" || p.status === "Leased").reduce((sum, p) => sum + toNumber(p.area), 0);
      const occupiedParcels = parkParcels.filter(p => p.occupancy_status === "Occupied" || p.status === "Leased").length;
      const parkSheds = shedsData.filter(s => toNumber(s.park_id) === toNumber(park.id));
      const occupiedSheds = parkSheds.filter(s => s.status_utilization === "Occupied").length;
      const parcelArea = parkParcels.reduce((sum, p) => sum + toNumber(p.area), 0);
      const shedArea = parkSheds.reduce((sum, s) => sum + toNumber(s.shed_size), 0);
      
      totalParkArea += parkArea;
      totalOccupiedArea += occupiedArea;
      totalParcels += parkParcels.length;
      totalOccupiedParcels += occupiedParcels;
      totalSheds += parkSheds.length;
      totalOccupiedSheds += occupiedSheds;
      totalParcelArea += parcelArea;
      totalShedArea += shedArea;
      totalGreenArea += calculateGreenAreaTotal(park.id);
      totalRoadArea += calculateRoadAreaTotal(park.id);
    });
    
    setSummaryStats({
      occupancyRate: totalParkArea > 0 ? (totalOccupiedArea / totalParkArea) * 100 : 0,
      parcelRatio: totalParcels > 0 ? (totalOccupiedParcels / totalParcels) * 100 : 0,
      totalParkArea, totalOccupiedArea, totalParcels, totalOccupiedParcels,
      totalParks: parksData.length, totalSheds, totalShedArea, totalParcelArea,
      totalOccupiedSheds, shedOccupancy: totalSheds > 0 ? (totalOccupiedSheds / totalSheds) * 100 : 0
    });
    
    setLandUseData({ 'Parcels': totalParcelArea, 'Green Areas': totalGreenArea, 'Roads': totalRoadArea });
    
    let totalLeasedLand = 0, occupiedLeasedLand = 0;
    landLeasedData.forEach(item => {
      const parcel = parcelsData.find(p => p.upin === item.upin);
      const area = parcel ? toNumber(parcel.area) : 0;
      totalLeasedLand += area;
      if (item.parcel_state === 'Occupied') occupiedLeasedLand += area;
    });
    setLeasedLandStats({ totalLeasedLand, occupiedLeasedLand, landLeaseRatio: totalLeasedLand > 0 ? (occupiedLeasedLand / totalLeasedLand) * 100 : 0 });
  }, [parksData, parcelsData, shedsData, landLeasedData, calculateGreenAreaTotal, calculateRoadAreaTotal]);
  
  const calculatePromotionMetrics = useCallback(() => {
    const totalInvestors = investorsData.length;
    const totalPotential = potentialInvestors.length;
    const convertedCount = potentialInvestors.filter(pot => investorsData.some(inv => inv.email?.toLowerCase() === pot.email?.toLowerCase())).length;
    const conversionRate = totalPotential > 0 ? (convertedCount / totalPotential) * 100 : 0;
    const totalCapital = investorsData.reduce((s, i) => s + toNumber(i.capital), 0);
    
    const sectorDistribution = {};
    potentialInvestors.forEach(pot => { const sector = pot.sector_of_interest || "Unknown"; sectorDistribution[sector] = (sectorDistribution[sector] || 0) + 1; });
    const topSectors = Object.fromEntries(Object.entries(sectorDistribution).sort((a, b) => b[1] - a[1]).slice(0, 5));
    
    const parkDistribution = {};
    potentialInvestors.forEach(pot => { const park = pot.park_interested_in || "Unknown"; parkDistribution[park] = (parkDistribution[park] || 0) + 1; });
    const topParks = Object.fromEntries(Object.entries(parkDistribution).sort((a, b) => b[1] - a[1]).slice(0, 5));
    
    const countryDistribution = {};
    investorsData.forEach(inv => { const country = inv.nationality_origin || "Unknown"; countryDistribution[country] = (countryDistribution[country] || 0) + 1; });
    const topCountries = Object.fromEntries(Object.entries(countryDistribution).sort((a, b) => b[1] - a[1]).slice(0, 5));
    
    setPromotionStats({ totalInvestors, totalPotential, conversionRate, convertedCount, totalCapital, topSectors, topParks, topCountries });
  }, [investorsData, potentialInvestors]);
  
  // Chart data
  const revenueByPark = useMemo(() => {
    const map = {};
    revenueData.forEach(r => { if (r.park_name && r.park_name !== "N/A") map[r.park_name] = (map[r.park_name] || 0) + (r.amount || 0); });
    return Object.fromEntries(Object.entries(map).sort((a, b) => b[1] - a[1]).slice(0, 6));
  }, [revenueData]);

  const outstandingByPark = useMemo(() => {
    const map = {};
    arrearsData.forEach(a => { if (a.park_name && a.park_name !== "N/A") map[a.park_name] = (map[a.park_name] || 0) + (a.outstanding || 0); });
    return Object.fromEntries(Object.entries(map).sort((a, b) => b[1] - a[1]).slice(0, 6));
  }, [arrearsData]);
  
  const investmentByType = useMemo(() => {
    const map = {};
    investorsData.forEach(i => { const type = i.investment_type || "Other"; map[type] = (map[type] || 0) + 1; });
    return Object.fromEntries(Object.entries(map).sort((a, b) => b[1] - a[1]).slice(0, 5));
  }, [investorsData]);
  
  // ==================== FIXED: Get most recent employment per investor ====================
  const getMostRecentEmployment = useCallback((data) => {
    if (!data || !Array.isArray(data) || data.length === 0) return [];
    
    const investorMap = new Map();
    
    data.forEach(record => {
      const investorId = record.investor_id || record.id;
      if (!investorId) return;
      
      // Use activity_period_to or recorded_on for comparison
      const currentDate = new Date(record.activity_period_to || record.recorded_on || 0);
      
      if (!investorMap.has(investorId)) {
        investorMap.set(investorId, record);
      } else {
        const existingRecord = investorMap.get(investorId);
        const existingDate = new Date(existingRecord.activity_period_to || existingRecord.recorded_on || 0);
        
        if (currentDate > existingDate) {
          investorMap.set(investorId, record);
        }
      }
    });
    
    return Array.from(investorMap.values());
  }, []);

  // ==================== FIXED: Code2 Metrics using correct data ====================
  const code2Metrics = useMemo(() => {
    const totalRevenueUSD = revenueData.filter(r => normalizeCurrency(r.payment_mode) === "usd").reduce((s, r) => s + (r.amount || 0), 0);
    const totalRevenueETB = revenueData.filter(r => normalizeCurrency(r.payment_mode) === "birr").reduce((s, r) => s + (r.amount || 0), 0);
    const totalOutstandingUSD = arrearsData.filter(a => normalizeCurrency(a.payment_mode) === "usd").reduce((s, a) => s + (a.outstanding || 0), 0);
    const totalOutstandingETB = arrearsData.filter(a => normalizeCurrency(a.payment_mode) === "birr").reduce((s, a) => s + (a.outstanding || 0), 0);
    
    // ==================== FIXED: Total Export ====================
    const totalExport = tradeData.reduce((s, t) => s + (t.export_amount || 0), 0);
    
    // ==================== FIXED: Total Import ====================
    const totalImport = tradeData.reduce((s, t) => s + (t.import_amount || 0), 0);
    
    // ==================== FIXED: Total Employees (most recent per investor) ====================
    // Get most recent employment records
    const mostRecentEmployment = getMostRecentEmployment(employmentData);
    
    // Sum the employment values from most recent records
    const totalEmployees = mostRecentEmployment.reduce((s, e) => {
      // Use the 'employment' column directly if available
      const empValue = toNumber(e.employment);
      if (empValue > 0) return s + empValue;
      
      // Fallback: sum individual fields
      return s + 
        toNumber(e.emp_labor_female) + 
        toNumber(e.emp_labor_male) + 
        toNumber(e.emp_prof_female) + 
        toNumber(e.emp_prof_male);
    }, 0);
    
    return { 
      totalRevenueUSD, 
      totalRevenueETB, 
      totalOutstandingUSD, 
      totalOutstandingETB, 
      totalEmployees, 
      totalExport, 
      totalImport 
    };
  }, [revenueData, arrearsData, employmentData, tradeData, getMostRecentEmployment]);

  // Fetch all data
  useEffect(() => {
    const fetchAllData = async () => {
      setLoading(true);
      try {
        const [parks, parcels, sheds, greenAreas, roads, leasedland, revenue, arrears, employment, trade, investors, potential] = await Promise.all([
          GetDataFromApiWithParams(`parks/parksummary`),
          GetDataFromApiWithParams(`parks/parcelsummary`),
          GetDataFromApiWithParams(`parks/shedsummary`),
          GetDataFromApiWithParams(`parks/greenareasummary`),
          GetDataFromApiWithParams(`parks/roadsummary`),
          GetDataFromApiWithParams(`parks/landleasedsummary`),
          GetDataFromApiWithParams(`finances/revenuereport`),
          GetDataFromApiWithParams(`finances/arrearreport`),
          GetDataFromApiWithParams(`investors/getemployment`), // Employment data
          GetDataFromApiWithParams(`investors/gettradedata`), // FIXED: Trade data from correct endpoint
          GetDataFromApiWithParams(`investors/getinverstor`),
          GetDataFromApiWithParams(`prospectiveInvestors`)
        ]);
        
        setParksData(parks || []);
        setParcelsData(parcels || []);
        setShedsData((sheds || []).map(s => ({ ...s, park_id: toNumber(s.park_id), shed_size: toNumber(s.shed_size) })));
        setGreenAreasData(greenAreas || []);
        setRoadsData(roads || []);
        setLandLeasedData(leasedland || []);
        
        const processRevenue = (data) => {
          let arr = data && Array.isArray(data) ? data : (data?.data || []);
          return arr.map(item => ({
            amount: toNumber(item.amount || item.payment_amount || 0),
            payment_mode: item.payment_mode || "USD",
            park_name: item.park_name || item.park,
            company_name: item.company_name,
            month: item.month || (item.payment_date ? format(new Date(item.payment_date), 'MM') : "01"),
            year: item.year || (item.payment_date ? format(new Date(item.payment_date), 'yyyy') : "2024")
          }));
        };
        
        const processArrears = (data) => {
          let arr = data && Array.isArray(data) ? data : (data?.data || []);
          return arr.map(item => ({
            outstanding: toNumber(item.outstanding || 0),
            payment_mode: item.payment_mode || "USD",
            park_name: item.park,
            company_name: item.company_name,
            overdue_days: item.overdue_date || 0,
            month: item.month || "01",
            year: item.year || "2024"
          }));
        };
        
        const processEmployment = (data) => {
          let arr = data && Array.isArray(data) ? data : (data?.data || []);
          return arr.map(item => ({
            investor_id: item.investor_id || item.id,
            emp_labor_female: toNumber(item.emp_labor_female),
            emp_labor_male: toNumber(item.emp_labor_male),
            emp_prof_female: toNumber(item.emp_prof_female),
            emp_prof_male: toNumber(item.emp_prof_male),
            employment: toNumber(item.employment),
            park_name: item.park_name,
            year: item.year || "2024",
            recorded_on: item.recorded_on,
            activity_period_to: item.activity_period_to
          }));
        };
        
        const processTrade = (data) => {
          let arr = data && Array.isArray(data) ? data : (data?.data || []);
          return arr.map(item => ({
            export_amount: toNumber(item.export_amount),
            import_amount: toNumber(item.import || item.import_amount || 0),
            import_substitution: toNumber(item.import_substitution),
            linkage_money: toNumber(item.linkage_money),
            park_name: item.park_name,
            year: item.year || "2024",
            investor_id: item.investor_id,
            recorded_on: item.recorded_on
          }));
        };
        
        const processInvestors = (data) => {
          let arr = data && Array.isArray(data) ? data : (data?.data || []);
          return arr.map(item => ({
            id: item.id,
            company_name: item.company_name,
            capital: toNumber(item.capital),
            nationality_origin: item.nationality_origin,
            status: item.status,
            email: item.email,
            investment_type: item.investment_type
          }));
        };
        
        // Process all data
        const processedRevenue = processRevenue(revenue);
        const processedArrears = processArrears(arrears);
        const processedEmployment = processEmployment(employment);
        const processedTrade = processTrade(trade);
        const processedInvestors = processInvestors(investors);
        
        console.log("Employment Data:", processedEmployment);
        console.log("Trade Data:", processedTrade);
        
        setRevenueData(processedRevenue);
        setArrearsData(processedArrears);
        setEmploymentData(processedEmployment);
        setTradeData(processedTrade);
        setInvestorsData(processedInvestors);
        setPotentialInvestors(potential && Array.isArray(potential) ? potential : (potential?.data || []));
        
      } catch (error) {
        console.error("Failed to fetch data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchAllData();
  }, []);
  
  useEffect(() => { if (parksData.length) calculateSummaryStats(); }, [parksData, parcelsData, shedsData, landLeasedData, calculateSummaryStats]);
  useEffect(() => { if (investorsData.length || potentialInvestors.length) calculatePromotionMetrics(); }, [investorsData, potentialInvestors, calculatePromotionMetrics]);
  
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress /><Typography sx={{ ml: 2 }}>Loading dashboard data...</Typography>
      </Box>
    );
  }
  
  return (
    <Box sx={{ bgcolor: '#f4f9ff', width: '100%', mx: 0, py: 1 }}>
      {/* Header with margins */}
      <Box sx={{ color: 'white', py: 2, px: { xs: 2, sm: 3, md: 4 }, bgcolor: '#f4f9ff' }}>
        <Container maxWidth="xl" sx={{ px: { xs: 1, sm: 2, md: 3 } }}>
          <IPDCWelcomeMessage messageTitle="CEO" />
        </Container>
      </Box>

      {/* BOLD LINE SEPARATOR 1 with margins */}
      <Container maxWidth="xl" sx={{ my: 4, px: { xs: 2, sm: 3, md: 4 } }}>
        <Box sx={{ borderBottom: '2px solid #e0e0e0', width: '100%' }} />
      </Container>
      
      {/* ========== SECTION 2: LAND & INFRASTRUCTURE ========== */}
      <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, ml: { xs: 1, sm: 2 } }}>
          <AgricultureIcon sx={{ color: '#1976d2', mr: 1 }} />
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1a237e' }}>Land & Infrastructure Metrics</Typography>
        </Box>
        <Grid container spacing={2} sx={{ mb: 3, px: { xs: 1, sm: 2 } }}>
          <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex' }}>
            <Card sx={{ p: 2, bgcolor: '#e3f2fd', width: '100%', display: 'flex', flexDirection: 'column' }}>
            <Typography variant="caption" sx={{ fontSize: '1.2rem' }}>
              Occupancy Rate
            </Typography>
              <Typography variant="h5" fontWeight="bold">{formatPercentage(summaryStats.occupancyRate)}</Typography>
              <ProgressBarCell value={summaryStats.occupancyRate} label="Occupancy" />
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex' }}>
            <Card sx={{ p: 2, bgcolor: '#e3f2fd', width: '100%', display: 'flex', flexDirection: 'column' }}>
              <Typography variant="caption" sx={{ fontSize: '1.2rem' }}>Parcel Ratio</Typography>
              <Typography variant="h5" fontWeight="bold">{formatPercentage(summaryStats.parcelRatio)}</Typography>
              <ProgressBarCell value={summaryStats.parcelRatio} label="Parcel" color="#1976d2" />
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex' }}>
            <Card sx={{ p: 2, bgcolor: '#e3f2fd', width: '100%', display: 'flex', flexDirection: 'column' }}>
              <Typography variant="caption" sx={{ fontSize: '1.2rem' }}>Shed Occupancy</Typography>
              <Typography variant="h5" fontWeight="bold">{formatPercentage(summaryStats.shedOccupancy)}</Typography>
              <ProgressBarCell value={summaryStats.shedOccupancy} label="Shed" color="#795548" />
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex' }}>
            <Card sx={{ p: 2, bgcolor: '#e3f2fd', width: '100%', display: 'flex', flexDirection: 'column' }}>
              <Typography variant="caption" sx={{ fontSize: '1.2rem' }}>Land Lease Ratio</Typography>
              <Typography variant="h5" fontWeight="bold">{formatPercentage(leasedLandStats.landLeaseRatio)}</Typography>
              <ProgressBarCell value={leasedLandStats.landLeaseRatio} label="Leased Land" color="#4caf50" />
            </Card>
          </Grid>
        </Grid>
      </Container>

      {/* BOLD LINE SEPARATOR 2 with margins */}
      <Container maxWidth="xl" sx={{ my: 4, px: { xs: 2, sm: 3, md: 4 } }}>
        <Box sx={{ borderBottom: '2px solid #e0e0e0', width: '100%' }} />
      </Container>
      
      {/* ========== SECTION 3: FINANCIAL CHARTS ========== */}
      <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, ml: { xs: 1, sm: 2 } }}>
          <BarChartIcon sx={{ color: '#1976d2', mr: 1 }} />
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1a237e' }}>Financial Analytics</Typography>
        </Box>

        {/* KPI Row - Equal height cards */}
        <Grid container spacing={2} sx={{ mb: 3, px: { xs: 1, sm: 2 } }}>
          <Grid item xs={6} md={3} sx={{ display: 'flex' }}>
            <Card sx={{ p: 2, bgcolor: '#F7F1F1', width: '100%', display: 'flex', flexDirection: 'column' }}>
              <Typography variant="caption" sx={{ fontSize: '1.2rem' }}>Revenue (USD)</Typography>
              <Typography variant="h6" fontWeight="bold" color="#2e7d32">{formatCurrencyUSD(code2Metrics.totalRevenueUSD)}</Typography>
            </Card>
          </Grid>
          <Grid item xs={6} md={3} sx={{ display: 'flex' }}>
            <Card sx={{ p: 2, bgcolor: '#F7F1F1', width: '100%', display: 'flex', flexDirection: 'column' }}>
              <Typography variant="caption" sx={{ fontSize: '1.2rem' }}>Outstanding (USD)</Typography>
              <Typography variant="h6" fontWeight="bold" color="#d32f2f">{formatCurrencyUSD(code2Metrics.totalOutstandingUSD)}</Typography>
            </Card>
          </Grid>
          <Grid item xs={6} md={3} sx={{ display: 'flex' }}>
            <Card sx={{ p: 2, bgcolor: '#F7F1F1', width: '100%', display: 'flex', flexDirection: 'column' }}>
              <Typography variant="caption" sx={{ fontSize: '1.2rem' }} >Revenue (ETB)</Typography>
              <Typography variant="h6" fontWeight="bold" color="#2e7d32">{formatCurrencyETB(code2Metrics.totalRevenueETB)}</Typography>
            </Card>
          </Grid>
          <Grid item xs={6} md={3} sx={{ display: 'flex' }}>
            <Card sx={{ p: 2, bgcolor: '#F7F1F1', width: '100%', display: 'flex', flexDirection: 'column' }}>
              <Typography variant="caption"  sx={{ fontSize: '1.2rem' }}
              >Outstanding (ETB)</Typography>
              <Typography variant="h6" fontWeight="bold" color="#d32f2f">{formatCurrencyETB(code2Metrics.totalOutstandingETB)}</Typography>
            </Card>
          </Grid>
        </Grid>

        {/* Charts Row - Equal height cards */}
        <Grid container spacing={2} sx={{ px: { xs: 1, sm: 2 } }}>
          <Grid item xs={12} md={4} sx={{ display: 'flex' }}>
            <Box sx={{ width: '100%', height: '100%' }}>
              <HorizontalBarChart title="Revenue by Park" data={revenueByPark} dataKey="value" color="#1976d2" formatValue={formatCurrencyUSD} />
            </Box>
          </Grid>
          <Grid item xs={12} md={4} sx={{ display: 'flex' }}>
            <Box sx={{ width: '100%', height: '100%' }}>
              <DonutChartComponent title="Outstanding by Park" data={outstandingByPark} formatValue={formatCurrencyUSD} colors={['#d32f2f', '#f44336', '#ff9800']} />
            </Box>
          </Grid>
          <Grid item xs={12} md={4} sx={{ display: 'flex' }}>
            <Card sx={{ p: 2, width: '100%', display: 'flex', flexDirection: 'column' }}>
              <Typography variant="subtitle1"  mb={2} sx={{ fontSize: '1.2rem' }}>Invoice Status Tracker</Typography>
              <InvoiceStatusTracker revenueData={revenueData} arrearsData={arrearsData} />
            </Card>
          </Grid>
        </Grid>
      </Container>

      {/* BOLD LINE SEPARATOR 3 with margins */}
      <Container maxWidth="xl" sx={{ my: 4, px: { xs: 2, sm: 3, md: 4 } }}>
        <Box sx={{ borderBottom: '2px solid #e0e0e0', width: '100%' }} />
      </Container>
      
      {/* ========== SECTION 4: INVESTOR AFTERCARE ========== */}
      <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, ml: { xs: 1, sm: 2 } }}>
          <PeopleIcon sx={{ color: '#1976d2', mr: 1 }} />
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1a237e' }}>Investor Aftercare</Typography>
        </Box>
        
        {/* KPI Cards Row - Equal height cards */}
        <Grid container spacing={2} sx={{ mb: 3, px: { xs: 1, sm: 2 } }}>
          <Grid item xs={6} sm={3} md={2} sx={{ display: 'flex' }}>
            <Card sx={{ bgcolor: '#e8f5e9', p: 2, textAlign: 'center', width: '100%', display: 'flex', flexDirection: 'column' }}>
              <Typography variant="caption" sx={{ fontSize: '1.2rem' }}>Total Parks</Typography>
              <Typography variant="h5" fontWeight="bold" color="#1976d2">13</Typography>
            </Card>
          </Grid>
          <Grid item xs={6} sm={3} md={2} sx={{ display: 'flex' }}>
            <Card sx={{ bgcolor: '#e8f5e9', p: 2, textAlign: 'center', width: '100%', display: 'flex', flexDirection: 'column' }}>
              <Typography variant="caption" sx={{ fontSize: '1.2rem' }}>Total Investors</Typography>
              <Typography variant="h5" fontWeight="bold" color="#1976d2">{formatNumber(promotionStats.totalInvestors)}</Typography>
            </Card>
          </Grid>
          <Grid item xs={6} sm={3} md={2} sx={{ display: 'flex' }}>
            <Card sx={{ p: 2, bgcolor: '#e8f5e9', textAlign: 'center', width: '100%', display: 'flex', flexDirection: 'column' }}>
              <Typography variant="caption" sx={{ fontSize: '1.2rem' }}>Total Export</Typography>
              <Typography variant="h6" fontWeight="bold" color="#2e7d32">{formatCurrencyUSD(code2Metrics.totalExport)}</Typography>
            </Card>
          </Grid>
          <Grid item xs={6} sm={3} md={2} sx={{ display: 'flex' }}>
            <Card sx={{ p: 2, bgcolor: '#e8f5e9', textAlign: 'center', width: '100%', display: 'flex', flexDirection: 'column' }}>
              <Typography variant="caption" sx={{ fontSize: '1.2rem' }}>Total Import</Typography>
              <Typography variant="h6" fontWeight="bold" color="#ed6c02">{formatCurrencyUSD(code2Metrics.totalImport)}</Typography>
            </Card>
          </Grid>
          <Grid item xs={6} sm={3} md={2} sx={{ display: 'flex' }}>
            <Card sx={{ p: 2, bgcolor: '#e8f5e9', textAlign: 'center', width: '100%', display: 'flex', flexDirection: 'column' }}>
              <Typography variant="caption" sx={{ fontSize: '1.2rem' }}>Total Employees</Typography>
              <Typography variant="h6" fontWeight="bold">{formatNumber(code2Metrics.totalEmployees)}</Typography>
            </Card>
          </Grid>
          <Grid item xs={6} sm={3} md={2} sx={{ display: 'flex' }}>
            <Card sx={{ p: 2, bgcolor: '#e8f5e9', textAlign: 'center', width: '100%', display: 'flex', flexDirection: 'column' }}>
              <Typography variant="caption" sx={{ fontSize: '1.2rem' }}>Total Capital</Typography>
              <Typography variant="caption" sx={{ fontSize: '1rem' }}  color="#9c27b0">{formatCurrencyUSD(promotionStats.totalCapital)}</Typography>
            </Card>
          </Grid>
        </Grid>

        {/* Charts Row - Equal height cards */}
        <Grid container spacing={2} sx={{ px: { xs: 1, sm: 2 } }}>
          <Grid item xs={12} md={4} sx={{ display: 'flex' }}>
            <Box sx={{ width: '100%', height: '100%' }}>
              <DonutChartComponent title="Investment Types" data={investmentByType} formatValue={formatNumber} />
            </Box>
          </Grid>
          <Grid item xs={12} md={4} sx={{ display: 'flex' }}>
            <Box sx={{ width: '100%', height: '100%' }}>
              <LandUsePieChart data={landUseData} total={summaryStats.totalParcelArea + landUseData['Green Areas'] + landUseData['Roads']} formatValue={formatNumber} />
            </Box>
          </Grid>
          <Grid item xs={12} md={4} sx={{ display: 'flex' }}>
            <Box sx={{ width: '100%', height: '100%' }}>
              <ParksBySectorCard wrapLegendText={true} />
            </Box>
          </Grid>
        </Grid>
      </Container>

      {/* BOLD LINE SEPARATOR 5 with margins */}
      <Container maxWidth="xl" sx={{ my: 4, px: { xs: 2, sm: 3, md: 4 } }}>
        <Box sx={{ borderBottom: '2px solid #e0e0e0', width: '100%' }} />
      </Container>
      
      {/* ========== SECTION 6: PROMOTION & MARKETING ========== */}
      <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, ml: { xs: 1, sm: 2 } }}>
          <TrendingUpIcon sx={{ color: '#1976d2', mr: 1 }} />
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1a237e' }}>Promotion & Marketing</Typography>
        </Box>
        <Grid container spacing={2} sx={{ mb: 3, px: { xs: 1, sm: 2 } }}>
          <Grid item xs={4} sx={{ display: 'flex' }}>
            <Card sx={{ p: 2, bgcolor: '#e8f5e9', textAlign: 'center', width: '100%', display: 'flex', flexDirection: 'column' }}>
              <Typography variant="caption" sx={{ fontSize: '1.4rem' }}>Total Investors</Typography>
              <Typography variant="h5" fontWeight="bold" color="#1976d2">{formatNumber(promotionStats.totalInvestors)}</Typography>
            </Card>
          </Grid>
          <Grid item xs={4} sx={{ display: 'flex' }}>
            <Card sx={{ p: 2, bgcolor: '#e8f5e9', textAlign: 'center', width: '100%', display: 'flex', flexDirection: 'column' }}>
              <Typography variant="caption" sx={{ fontSize: '1.2rem' }}>Potential Investors</Typography>
              <Typography variant="h5" fontWeight="bold" color="#ed6c02">{formatNumber(promotionStats.totalPotential)}</Typography>
            </Card>
          </Grid>
          <Grid item xs={4} sx={{ display: 'flex' }}>
            <Card sx={{ p: 2, bgcolor: '#e8f5e9', textAlign: 'center', width: '100%', display: 'flex', flexDirection: 'column' }}>
              <Typography variant="caption" sx={{ fontSize: '1.2rem' }}>Conversion Rate</Typography>
              <Typography variant="h5" fontWeight="bold" color="#2e7d32">{formatPercentage(promotionStats.conversionRate)}</Typography>
            </Card>
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ px: { xs: 1, sm: 2 } }}>
          <Grid item xs={12} md={4} sx={{ display: 'flex' }}>
            <Box sx={{ width: '100%', height: '100%' }}>
              <HorizontalBarChart title="Top Sectors of Interest" data={promotionStats.topSectors} dataKey="value" color="#ff9800" formatValue={formatNumber} />
            </Box>
          </Grid>
          <Grid item xs={12} md={4} sx={{ display: 'flex' }}>
            <Box sx={{ width: '100%', height: '100%' }}>
              <DonutChartComponent title="Top Parks Interest" data={promotionStats.topParks} formatValue={formatNumber} />
            </Box>
          </Grid>
          <Grid item xs={12} md={4} sx={{ display: 'flex' }}>
            <Box sx={{ width: '100%', height: '100%' }}>
              <ConversionGaugeChart conversionRate={promotionStats.conversionRate} potentialCount={promotionStats.totalPotential} investorCount={promotionStats.convertedCount} />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
} 